module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/menu-62153447d9c2988343885c6e5fd6f2a3.svg";